// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-5135cd28] .sida-modal {\n  max-width: 500px;\n}\n[data-v-5135cd28] .sida-modal .modal-content {\n  height: auto;\n  font-size: 18px;\n  text-align: justify;\n}\n", ""]);
// Exports
module.exports = exports;
